export default "__VITE_ASSET__Dg_2fiw3__"